import { GeoJSON, useMap } from 'react-leaflet';
import type { FeatureCollection } from 'geojson';
import L, { PathOptions } from 'leaflet';

type RegulatoryDistrictLayerProps = {
  regulatoryBoundaries: FeatureCollection;
};

// Default style for the geometries
const defaultStyle: PathOptions = {
  color: '#3388ff',
  opacity: 1,
  fillOpacity: 0.2,
};

// Highlight style for when a feature is hovered
const highlightStyle: PathOptions = {
  color: '#ff7800',
  weight: 3,
  opacity: 1,
  fillOpacity: 0.5,
};

const RegulatoryDistrictLayer = ({ regulatoryBoundaries }: RegulatoryDistrictLayerProps) => {
  const map = useMap();

  return (
    <GeoJSON
      data={regulatoryBoundaries}
      style={defaultStyle}
      onEachFeature={(feature, layer) => {
        const districtLayer = layer as L.Polygon;

        const district = feature.properties?.DISTRICT;
        const districtAbbreviation = feature.properties?.DIST_ABBR;

        if (district && districtAbbreviation) {
          districtLayer.bindTooltip(`${district} (${districtAbbreviation})`, {
            permanent: false,
            direction: 'center',
            className: 'district-label',
          });
        }

        // Add mouseover event to highlight the feature
        districtLayer.on('mouseover', () => {
          districtLayer.setStyle(highlightStyle);
        });

        // Add mouseout event to reset to the default style
        districtLayer.on('mouseout', () => {
          districtLayer.setStyle(defaultStyle);
        });

        districtLayer.on('click', () => {
          map.fitBounds(districtLayer.getBounds()); // Zoom to the bounds of the geometry
        });
      }}
    />
  );
};

export default RegulatoryDistrictLayer;
